import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import parse, { domToReact } from "html-react-parser";
import GetPrice from "../Functions/GetPrice";
import { convertToPersian } from "../Functions/TextTransform";
import { useMediaQuery } from "react-responsive";
import { imgUrl , baseURLCats } from "../config/api";


function Curtain() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [pageLanguage, setPageLanguage] = useState(location.pathname.substring(1, 3));
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const { catID } = useParams();
  const [models, setModels] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [mobModelList, setMobModelList] = useState([]);
  const [defaultModelName, setDefaultModelName] = useState("");
  const [defaultModelNameFa, setDefaultModelNameFa] = useState("");
  const [defaultDesc, setDefaultDesc] = useState("");
  const [defaultDescFa, setDefaultDescFa] = useState("");

  const getCats = useCallback(() => {
    axios
      .get(baseURLCats, {
        params: {
          pageName: catID,
        },
      })
      .then((response) => {
        const visibleChildPages =
          response.data.ChildPages?.filter((page) => page.ShowWithChild === true) ?? [];

        if (visibleChildPages.length) {
          setModels(visibleChildPages);
          setDefaultModelName(response.data.EnTitle);
          setDefaultModelNameFa(convertToPersian(response.data.Title));
          setDefaultDesc(response.data.DescriptionEn);
          setDefaultDescFa(convertToPersian(response.data.Description));
        } else {
          setModelList(<p>No Page Item</p>);
        }
      })
      .catch((err) => {
        console.error(err);
        navigate(`/${pageLanguage}`);
      });
  }, [catID, pageLanguage, navigate, convertToPersian]);

  const createModelItem = useCallback(
    (model, index, isMobile) => {
      const {
        Link: tempLink = "",
        WebsitePageId,
        Title,
        EnTitle,
        DiscountDesc,
        DiscountEnDesc,
        HtmlContent,
        HtmlEnContent,
        Price: StartPrice,
        DiscountPrice,
        ImageUrl: PhotoUrl,
      } = model;

      const isLink = tempLink[0] === "/";
      const SewingModelId = tempLink;
      const ModelName = convertToPersian(Title);
      const ModelENName = EnTitle;
      const Description = HtmlContent || "";
      const ENDescription = HtmlEnContent || "";
      const discount = StartPrice !== DiscountPrice;

      const options = {
        replace: (domNode) => {
          if (domNode.type === "text" && pageLanguage === "fa" && domNode.data?.trim()) {
            return <>{convertToPersian(domNode.data)}</>;
          }
          switch (domNode.name) {
            case "h1":
              return (
                <h1 className="model_item_info_description_title">
                  {domToReact(domNode.children, options)}
                </h1>
              );
            case "p":
              return (
                <p className="model_item_info_description_body">
                  {domToReact(domNode.children, options)}
                </p>
              );
            case "h2":
              return <h2 className="model_item_info_description_key_features" />;
            case "ul":
              return <ul className="model_item_info_description_bullets" />;
            case "li":
              return <li className="model_item_info_description_key_features_item" />;
            default:
              return null;
          }
        },
      };

      const getModelImage = () => {
        const imageUrl = PhotoUrl
          ?  imgUrl(PhotoUrl)
          : `${process.env.PUBLIC_URL}/no_image.svg`;
        const linkClassName = "model_image_container model_image_container_new 1";
        let linkTo;

        if (!isLink && SewingModelId === "0321") {
          linkTo = `/${pageLanguage}/Curtain/${catID}/Selection`;
        } else if (!isLink && SewingModelId === "0099") {
          linkTo = `/${pageLanguage}/Curtain/grommet/Selection`;
        } else if (!isLink) {
          linkTo = `/${pageLanguage}/Curtain/${catID}/${SewingModelId}`;
        } else {
          linkTo = `/${pageLanguage}${SewingModelId}`;
        }

        return (
          <Link to={linkTo} className={linkClassName} onClick={() => sessionStorage.clear()}>
            <img
              src={imageUrl}
              // src={`${imageUrl}?t=${Date.now()}`}
              className="img-fluid"
              alt=""
            />
          </Link>
        );
      };

      const getModelInfo = () => {
        let linkTo;
        if (!isLink) {
          linkTo = `/${pageLanguage}/Curtain/${catID}/${SewingModelId}/Page-ID/${WebsitePageId}`;
        } else {
          linkTo = `/${pageLanguage}${SewingModelId}`;
        }

        return (
          <div className="model_item_info_container model_item_info_title_mobile">
            <Link to={linkTo} className="model_item_info_title model_item_info_title_fs_mob">
              {pageLanguage === "en" ? ModelENName : ModelName}
            </Link>
            <h3 className="model_item_info_price_from model_item_info_price_from_fs_mob">
              {pageLanguage === "en" ? "prices from" : "قیمت از"}
            </h3>
            <span
              className={
                discount
                  ? "model_item_info_price model_item_info_price2 model_item_info_price_fs_mob"
                  : "model_item_info_price model_item_info_price_fs_mob"
              }
            >
              {GetPrice(StartPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
            </span>
            {discount && <span>&nbsp;|&nbsp;</span>}
            {discount && (
              <span className="model_item_info_price_off">
                {GetPrice(DiscountPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
              </span>
            )}
            <div className="model_item_info_description_section model_item_info_description_section_fs_mob">
              {pageLanguage === "en"
                ? parse(ENDescription, options)
                : parse(Description, options)}
            </div>
            {getCustomizationButton()}
          </div>
        );
      };

      const getCustomizationButton = () => {
        let linkTo;
        const buttonText = pageLanguage === "fa" ? "سفارش دهید" : "Start Customizing";

        if (!isLink && SewingModelId === "0321") {
          linkTo = `/${pageLanguage}/Curtain/${catID}/Selection`;
        } else if (!isLink && SewingModelId === "0099") {
          linkTo = `/${pageLanguage}/Curtain/grommet/Selection`;
        } else if (!isLink) {
          linkTo = `/${pageLanguage}/Curtain/${catID}/${SewingModelId}/Page-ID/${WebsitePageId}`;
        } else {
          linkTo = `/${pageLanguage}${SewingModelId}`;
        }

        return (
          <Link
            to={linkTo}
            className="btn_normal model_item_btn_normal"
            onClick={() => sessionStorage.clear()}
          >
            {buttonText}
          </Link>
        );
      };

      return (
        <li
          key={`${isMobile ? "mob_model" : "model"}${index}`}
          model_id={index}
          className={`${index % 2 === 0 ? "model_color_1" : "model_color_2"}`}
        >
          {getModelImage()}
          <div className="model_info_container">{getModelInfo()}</div>
        </li>
      );
    },
    [pageLanguage, catID, isTabletOrMobile, t, convertToPersian]
  );

  const renderModels = useCallback(() => {
    const modelItems = models.map((model, index) => createModelItem(model, index, false));
    const mobileModelItems = models.map((model, index) => createModelItem(model, index, true));

    setModelList(modelItems);
    setMobModelList(mobileModelItems);
  }, [models, createModelItem]);

  useEffect(() => {
    const currentPathLanguage = location.pathname.substring(1, 3);
    if (pageLanguage !== currentPathLanguage) {
      setPageLanguage(currentPathLanguage);
    }
  }, [location.pathname, pageLanguage]);

  useEffect(() => {
    if (models.length) {
      renderModels();
    }
  }, [models, renderModels]);

  useEffect(() => {
    if (pageLanguage) {
      getCats();
    }
  }, [pageLanguage, location.pathname, getCats]);

  useEffect(() => {
    renderModels();
  }, [pageLanguage, location.pathname, renderModels]);

  const pageClassName = useMemo(
    () => `Drapery_page_container ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`,
    [pageLanguage]
  );

  const modelTitle = useMemo(
    () =>
      defaultModelName &&
      (pageLanguage === "fa" ? convertToPersian(defaultModelNameFa) : defaultModelName),
    [defaultModelName, defaultModelNameFa, pageLanguage]
  );

  return (
    <div className={pageClassName}>
      <div className="models_title_div">
        <h1>{modelTitle}</h1>
        <h2>{pageLanguage === "fa" ? defaultDescFa : defaultDesc}</h2>
      </div>
      <div className="cat_models_list_container">
        <hr />
        <ul className="cat_models_list desktop_only">{modelList}</ul>
        <ul className="cat_models_list mobile_only">{mobModelList}</ul>
      </div>
    </div>
  );
}

export default Curtain;
